import { ReactNode } from 'react'
import { usePositionEditor } from './usePositionEditor'
import { Button, ModalCtaContainer } from 'ui'

export function Footer(props: { ctaText?: string; leftContent?: ReactNode }) {
  const { canGoBack, isSaving, goBack } = usePositionEditor()

  return (
    <ModalCtaContainer>
      {props.leftContent}
      {canGoBack ? (
        <Button variant={'text'} onClick={goBack}>
          Back
        </Button>
      ) : null}
      <Button loading={isSaving} type={'submit'}>
        {props.ctaText ?? 'Next'}
      </Button>
    </ModalCtaContainer>
  )
}
